import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getInventorySessions(filterBy, view, currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/getInventorySessions`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },

    addInventorySession(inventorySession, currUserId, currTimeStamp) {
        let url = `${config.cloudFunctionsBaseUrl}/addInventorySession`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            inventorySession: JSON.stringify(inventorySession)
        });
    },

    updateInventorySession(inventorySession, currUserId, currTimeStamp) {
        let url = `${config.cloudFunctionsBaseUrl}/updateInventorySession`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            inventorySession: JSON.stringify(inventorySession)
        });
    },

    cancelInventorySession(inventorySession, currUserId, currTimeStamp) {
        let url = `${config.cloudFunctionsBaseUrl}/cancelInventorySession`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            inventorySession: JSON.stringify(inventorySession)
        });
    },

    markInventorySessionAsDone(inventorySession, assets, currUserId, currTimeStamp) {
        let url = `${config.cloudFunctionsBaseUrl}/markInventorySessionAsDone`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            inventorySession: JSON.stringify(inventorySession),
            assets: JSON.stringify(assets)
        });
    },

}